import { IMODALITIES } from '@ifit/gateway-challenge-store';
import {
  IMembershipType,
  ulchallengesRowV2,
  IULChallengesRowV2Parameters,
  IUserLibraryChallengeItem,
} from '@ifit/gateway-wolf-athenaeum-service';
import { parseEqpTypeToModalityDash as getModality } from '@ifit/equipment-types';
import { FIFTEEN_SECONDS, ONE_DAY } from '../../util/durations';
import { useEquipmentType } from '../selectors/use-equipment-type';
import { useSoftwareNumber } from '../selectors/use-software-number';
import { useUserType } from '../selectors/use-user-type';
import { UseQueryResult, useQuery } from 'react-query';

export function useChallenges(
  optionalEquipmentType: string | null = null
): UseQueryResult<IUserLibraryChallengeItem[], Error> {
  let modality = getModality(useEquipmentType());
  const softwareNumber = useSoftwareNumber();
  if (`${softwareNumber}` === '433917') {
    modality = IMODALITIES.Yoga;
  }
  if (`${softwareNumber}` === '433918') {
    modality = IMODALITIES.Strength;
  }
  if (optionalEquipmentType === 'Elliptical') {
    modality = IMODALITIES.Elliptical;
  }

  const userType = useUserType();

  const parameters: IULChallengesRowV2Parameters = {
    modality,
    softwareNumber: parseInt(softwareNumber),
    membershipType: parseMembershipType(userType),
  };

  return useQuery(
    ['use-challenges', { softwareNumber, userType, modality }],
    () =>
      ulchallengesRowV2({ ...parameters }).then(({ data }) => {
        const currentChallenges = data[0]?.data ?? [];
        const pastChallenges = data[1]?.data ?? [];

        return [...currentChallenges, ...pastChallenges].slice(0, 10);
      }),
    {
      staleTime: FIFTEEN_SECONDS,
      cacheTime: ONE_DAY,
    }
  );
}

function parseMembershipType(userType): IMembershipType {
  switch (userType) {
    case 'premium':
      return IMembershipType.Premium;
    case 'free':
      return IMembershipType.Free;
    case 'anonymous':
      return IMembershipType.Free;
  }
}
